export default {
  companyScoreMetadata: {
    noTeams:
      'The «Create score» button will become available after creating at least one team and adding employees to it on the tab',
    tableHeaders: {
      evaluated: 'Evaluated',
      team: 'Team',
      specialty: 'Specialty',
      skills: 'Skills',
      progress: 'Progress',
      statistics: 'Statistics',
      test: 'Test',
      type: 'Type',
      appointed: 'Appointed',
      completed: 'Completed',
      approvalStatus: 'Approval status',
      result: 'Result',
      edit: 'Edit',
    },
    successMessages: {
      createReminders: 'Reminders sent successfully',
      setHiddenReports360:
        'The ability to view reports for the evaluated employees successfully changed',
      closeTests360: {
        close: 'The selected tests successfully closed for passing',
        open: 'The selected tests successfully opened for passing',
      },
      deleteTests360: 'The selected tests successfully deleted',
    },
    errorMessages: {
      report: 'The user has not yet passed the assessment, the report has not been created',
      roadmap:
        'The user has not yet passed the assessment, the development plan has not been created',
      createRoadmap: 'Failed to create a development plan',
      createReminders: 'Failed to send reminders',
      setHiddenReports360:
        'Failed to change the ability to view reports for the evaluated employees',
      closeTests360: {
        close: 'Failed to close the selected tests for passing',
        open: 'Failed to open the selected tests for passing',
      },
      deleteTests360: 'Failed to delete the selected tests',
      getVariantsPersonalReport: 'Failed to get reports variants',
      getLinkPersonalReport: 'Failed to get a link to the report',
    },
  },
};
